// extracted by mini-css-extract-plugin
export default {"responsive_divider":"styles_responsive_divider__zV+vR","expertise":"styles_expertise__dZ5sv"};